<template>
  <div class="common-parse-session-card-box" @click="cardClick">
    <div class="common-parse-session-card">
      <div class="card-title">{{ customContent.title }}</div>
      <div class="card-body">
        <span class="body-content">{{ customContent.text }}</span>
        <span class="body-blank" v-if="customContent.icon">
          <img :src="customContent.icon" width="40px" alt="">
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardMessage',
  props: {
    customContent: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    cardClick () {
      if (this.customContent.event === 'click' && this.customContent.actionType === 'blank') {
        window.open(this.customContent.action, '_blank')
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.common-parse-session-card-box {
  width: 200px;
  height: 80px;
  padding: 5px 16px;
  white-space: normal;
  cursor: pointer;
}
.card-body {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #999;
}
.body-content {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  white-space: normal;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: normal;
}
</style>



// WEBPACK FOOTER //
// src/common/im/right/chat/CardMessage.vue